import { useEffect, useState } from "react";
import { Form, Col, Row, Modal, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import {
  CheckCircleOutlined,
  CloseOutlined,
  UnorderedListOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import useDelete from "../../../global/hooks/useDelete";
import ConfirmModal from "../../../global/components/ConfirmModal";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
// import AccountForm from "../../../global/components/adminInfo";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import { RiAlignItemBottomFill } from "react-icons/ri";

export const HardwareForm = ({
  type,
  onCancel,
  isModalForm,
  setDefaultData: setAccountDefaultData,
  defaultData: accountDefaultData,
}) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [defaultData, setDefaultData] = useState({
    OemNo: null,
  });

  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const url = id && `${process.env.REACT_APP_API_URL}/api/hardwares/${id}/`;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/hardwares/`;
  const putUrl = `${process.env.REACT_APP_API_URL}/api/hardwares/${id}/`;
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/hardwares/${id}/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;

  const { data, loading, error, refetch } = useGet(url);

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  const modifiedOems = getModifiedResponse(optionData, "oems");
  const modifiedProducts = getModifiedResponse(optionData, "products");
  // const modifiedBillingCycles = getModifiedResponse(optionData, "bill_cycles");
  // const modifiedAutoBilling = getModifiedResponse(optionData, "auto_billings");

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);
  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(putUrl);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(deleteUrl);

  const onFinish = async (values) => {
    const modValues = {
      ...values,
    };
    try {
      if (id && !isModalForm) {
        await putAction(modValues);
      } else {
        await postAction(modValues);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");

      console.log(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    if (isModalForm) {
      form.resetFields(["HardwareName", "HardwareDesc"]);
    }
    onCancel ? onCancel() : navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  // Set default field value
  // useEffect(() => {
  //   if (!id) {
  //     form.setFieldsValue({
  //       OemNo: modifiedOems[0]?.value,
  //     });
  //   }
  // }, [modifiedOems]);

  useEffect(() => {
    if (!id || loading) return;
    const getAccountInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          form.setFieldsValue({
            OemNo: data?.data?.OemNo,
            Product: data?.data?.Product,
            HardwareName: String(data.data.HardwareName),
            HardwareDesc: data.data.HardwareDesc
              ? String(data.data.HardwareDesc)
              : "",
          });
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getAccountInfoById();
  }, [id, data, loading, form, type]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      setAccountDefaultData &&
        setAccountDefaultData((prev) => {
          return {
            ...prev,
            HardwareNo: postData?.data?.HardwareNo,
          };
        });
      setTimeout(() => {
        isModalForm ? onCancel() : navigate(-1);
      }, 200);
    }
  }, [postError, postData, postLoading]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong"
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");
      refetch();
      setTimeout(() => {
        navigate(-1);
      }, 200);
    }
  }, [putData, putLoading, putError]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/hardware");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (accountDefaultData) {
      form.setFieldsValue(accountDefaultData);
    }
  }, [accountDefaultData]);

  const breadcrumbItems = [
    {
      label: "Hardware",
      href: "/hardware",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/hardware/info/${id}`
          : `/hardware/edit/${id}`
        : "/hardware/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/hardware/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ].filter(Boolean)
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };
  useEffect(() => {
    optionDataRefetch();
    if (defaultData?.OemNo) {
      form.setFieldsValue(defaultData);
    } else if (accountDefaultData?.OemNo) {
      form.setFieldsValue(accountDefaultData);
    }
  }, [defaultData, accountDefaultData]);

  return (
    <>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          {!isModalForm && (
            <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
              <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
                <CommonButton buttonsData={buttonsData} />
              </CommonBreadcrumb>
            </div>
          )}
          {
            <div
              className={`bg-white overflow-hidden ${
                isModalForm ? "" : "border rounded-[4px]"
              }`}
            >
              {!isModalForm && (
                <div className="flex items-center bg-gray-200 p-2.5">
                  <RiAlignItemBottomFill className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2 ">
                    Hardware
                  </span>
                </div>
              )}
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Name"
                      name="HardwareName"
                      disabled={type === "info"}
                      required
                    />
                  </Col>
                  {/* </Row>
                  <Row gutter={[16, 16]}> */}
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Description"
                      name="HardwareDesc"
                      disabled={type === "info"}
                    />
                  </Col>

                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="OEM"
                      name="OemNo"
                      options={modifiedOems}
                      disabled={type === "info" || accountDefaultData?.OemNo}
                      placeholder="Please select"
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          OemNo: value,
                        }));
                      }}
                      required
                      handleCreateNew={
                        accountDefaultData?.OemNo ? null : handleCreateNew
                      }
                      type={"OEM"}
                    />
                  </Col>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="Product"
                      name="Product"
                      options={modifiedProducts}
                      disabled={type === "info"}
                      placeholder="Please select"
                      required
                    />
                  </Col>
                </Row>
              </div>
            </div>
          }
        </div>
      </Form>
      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button className="reset-button" onClick={onReset}>
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      )}

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </>
  );
};
